'use client';
import { Alert } from '@mantine/core';
import * as Sentry from '@sentry/nextjs';

import React, { useEffect } from 'react';

export default function Error({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <Alert color="red" title="Error">
      Looks like something went wrong.{' '}
    </Alert>
  );
}
